// extracted by mini-css-extract-plugin
export default {"modalFooter":"ManageDownloadClientsEditModalContent-modalFooter-lujmM ModalFooter-modalFooter-wjkx5","selected":"ManageDownloadClientsEditModalContent-selected-OpTW9"};